import { Logger, isNil } from "@visactor/vutils";

import { Layout } from "./layout";

export const transform = (options, upstreamData, parameters) => {
    if (!options.size || isNil(options.size[0]) || isNil(options.size[1]) || options.size[0] <= 0 || options.size[1] <= 0) {
        return Logger.getInstance().info("Wordcloud size dimensions must be greater than 0"), 
        [];
    }
    if (options.size = [ Math.ceil(options.size[0]), Math.ceil(options.size[1]) ], options.shape || Logger.getInstance().error("WordcloudShape shape must be specified."), 
    options.text || Logger.getInstance().error("WordcloudShape text must be specified."), 
    options.onBeforeLayout && options.onBeforeLayout(), !upstreamData || 0 === upstreamData.length) return [];
    const layout = new Layout(options);
    return layout.layout(upstreamData), layout.unfinished() ? {
        progressive: layout
    } : layout.output();
};
//# sourceMappingURL=wordcloud-shape.js.map
